import { render, staticRenderFns } from "./DrawingBoard.vue?vue&type=template&id=0ad04251&scoped=true&"
import script from "./DrawingBoard.vue?vue&type=script&lang=js&"
export * from "./DrawingBoard.vue?vue&type=script&lang=js&"
import style0 from "./DrawingBoard.vue?vue&type=style&index=0&id=0ad04251&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad04251",
  null
  
)

export default component.exports